module.exports = __webpack_public_path__ + "img/30exp.c23afb49.jpg";